import { face_angry, face_disgust, face_embarrassed } from '@assets/icons';
import { CheckboxItem, MenuTop, Output, Text } from '@components';
import { FacialExpressionChildOptionValueEnum, styleConstant } from '@constant';
import { useOutput } from '@hooks';
import { colorSet } from '@theme';
import { useCallback, useEffect, useState } from 'react';
import { throttle } from 'lodash';
import { useFacialExpressionActions } from '@remote-hooks';

const FacialExpressionOutputPage = () => {
  const { storedFacialExpressionChildOptionValue, onSetFacialExpression } = useOutput();

  const [showPageName, setShowPageName] = useState(false);
  // 마운트 상태를 추적하는 state
  const [isComponentMounted, setIsComponentMounted] = useState(false);

  const { onInitFacialExpression } = useFacialExpressionActions();

  // Throttled scroll handler
  const handleScroll = useCallback(
    throttle(() => {
      if (window.scrollY > styleConstant.topPageNameHeight) {
        setShowPageName(true);
      } else {
        setShowPageName(false);
      }
    }, 200), // 200ms 간격으로 호출되도록 설정
    []
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    setIsComponentMounted(true);
    if (!isComponentMounted) return;

    return () => {
      onInitFacialExpression();
    };
  }, [isComponentMounted, onInitFacialExpression]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <MenuTop pageName={showPageName ? '표정' : undefined} />

      {/* 옵션 */}
      <div
        style={{
          height: styleConstant.topPageNameHeight,
          padding: '40px',
          borderBottom: `1px solid ${colorSet.gray300}`
        }}
      >
        <Text variant="h2" fontWeight="bold">
          표정
        </Text>
      </div>

      <div style={{ display: 'flex' }}>
        {/* 좌측 메뉴 */}
        <div
          style={{
            width: styleConstant.outputPageLeftMenuWidth,
            padding: '24px 32px',
            backgroundColor: colorSet.gray100,
            boxSizing: 'border-box',
            position: 'sticky',
            top: styleConstant.menuTopHeight,
            minHeight: `calc(100vh - ${styleConstant.menuTopHeight + styleConstant.topPageNameHeight}px)`,
            maxHeight: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            borderRight: `1px solid ${colorSet.gray300}`
          }}
        >
          <Text variant="body1" fontWeight="bold">
            하위 스페셜 단추
          </Text>
          <div style={{ width: 224, padding: '8px 24px 8px 0px', marginTop: '8px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '24px 0px' }}>
              <CheckboxItem
                label="혐오"
                image={face_disgust}
                imageSize={48}
                isChecked={storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.혐오]}
                onChange={() => {
                  onSetFacialExpression({
                    [FacialExpressionChildOptionValueEnum.혐오]:
                      !storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.혐오]
                  });
                }}
              />
              <CheckboxItem
                label="분노"
                image={face_angry}
                imageSize={48}
                isChecked={storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.분노]}
                onChange={() => {
                  onSetFacialExpression({
                    [FacialExpressionChildOptionValueEnum.분노]:
                      !storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.분노]
                  });
                }}
              />
              <CheckboxItem
                label="당황"
                image={face_embarrassed}
                imageSize={48}
                isChecked={storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.당황]}
                onChange={() => {
                  onSetFacialExpression({
                    [FacialExpressionChildOptionValueEnum.당황]:
                      !storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.당황]
                  });
                }}
              />
            </div>
          </div>
        </div>

        {/* 검색 결과 */}
        <Output />
      </div>
    </div>
  );
};

export default FacialExpressionOutputPage;
